import {Tooltip} from "antd";
import React from "react";
import {truncate} from "lodash";

export const EXCenterTitleTooltip = ({title, minLength}) => (
    <Tooltip title={title && title.length > minLength ? title : void 0}>
        {truncate(title || "", {length: minLength})}
    </Tooltip>
);
